import React from 'react';
import { Layout } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';

import Content from '../../components/Pages/QcReports';
import { displayName } from '../../config';

const QcReports: React.FC = (): JSX.Element => {
  document.title = `${displayName}: QC Reports`;

  return (
    <Layout>
      <PageHeader title="QC Reports" />
      <Content />
    </Layout>
  );
};

export default QcReports;
